export const validPassword = new RegExp("[a-z]{2,}[0-9]{1,}");

export const validPhone = new RegExp("^[0-9]{11}$");
